export const accountViews = {
  botConfig: {
    breadcrumb: {
      listings: "Oferty",
      current: "Agent AI",
    },
    loading: "Wczytywanie konfiguracji...",
    retry: "Spróbuj ponownie",
    loadError: "Błąd podczas wczytywania konfiguracji.",
    units: "{count} jednostka | {count} jednostki | {count} jednostek",
    faqsLabel: "FAQ",
    unitFallback: "Jednostka",
    active: "Aktywny",
    inactive: "Nieaktywny",
    botWhatsapp: "Bot WhatsApp",
    otaIa: "AI dla OTA",
    saving: "Zapisywanie...",
    cancel: "Anuluj",
    assistant: {
      title: "Asystent WhatsApp",
      desc: "Włączenie bota automatycznie odpowiadającego gościom na WhatsApp.",
    },
    ota: {
      title: "AI dla OTA",
      desc: "Automatyczne odpowiedzi na wiadomości z Booking.com, Airbnb i innych OTA.",
      warn: "Najpierw trzeba włączyć Asystenta WhatsApp",
    },
    botName: {
      title: "Nazwa asystenta",
      desc: "Nazwa, którą bot będzie się przedstawiał gościom.",
      empty: "Nie przypisano nazwy",
      edit: "Edytuj",
      placeholder: "Np. Maria, Zofia, Wirtualny Asystent...",
      save: "Zapisz",
    },
    faqs: {
      title: "Najczęściej zadawane pytania",
      desc: "Te pytania obowiązują we <strong>wszystkich jednostkach</strong> tej oferty. Bot wykorzysta je w odpowiedziach dla gości.",
      add: "Nowe pytanie",
      emptyText: "Nie ma tu jeszcze żadnych najczęściej zadawanych pytań.",
      addFirst: "+ Dodaj pierwsze pytanie",
      answerEmpty: "Brak odpowiedzi",
      editTitle: "Edytuj",
      deleteTitle: "Usuń",
      questionLabel: "Pytanie",
      answerLabel: "Odpowiedź",
      questionPlaceholder: "Proszę wpisać pytanie...",
      answerPlaceholder: "Proszę wpisać odpowiedź, którą zobaczy gość...",
      saveChanges: "Zapisz zmiany",
    },
    addModal: {
      title: "Nowe często zadawane pytanie",
      questionLabel: "Pytanie",
      questionPlaceholder: "Np. O której godzinie jest check-in?",
      answerLabel: "Odpowiedź",
      answerPlaceholder: "Np. Check-in od 15:00. Przy wcześniejszym przyjeździe można zostawić bagaż...",
      submit: "Dodaj pytanie",
    },
    deleteModal: {
      title: "Usuń pytanie",
      confirm: "Czy na pewno usunąć to pytanie?",
      deleting: "Usuwanie...",
      submit: "Tak, usuń",
    },
    types: {
      apartment: "Apartament",
      house: "Dom",
      villa: "Willa",
      hotel: "Hotel",
      room: "Pokój",
      studio: "Kawalerka",
      default: "Obiekt",
    },
    toast: {
      botOn: "Bot włączony",
      botOff: "Bot wyłączony",
      botError: "Błąd podczas zmiany statusu bota",
      otaOn: "AI dla OTA włączone",
      otaOff: "AI dla OTA wyłączone",
      otaError: "Błąd podczas zmiany statusu AI dla OTA",
      nameUpdated: "Nazwa asystenta zaktualizowana",
      nameError: "Błąd podczas zapisywania nazwy",
      faqAdded: "Pytanie dodane pomyślnie",
      faqAddError: "Błąd podczas zapisywania pytania",
      faqUpdated: "Pytanie zaktualizowane",
      faqUpdateError: "Błąd podczas aktualizacji pytania",
      faqDeleted: "Pytanie usunięte",
      faqDeleteError: "Błąd podczas usuwania pytania",
    },
  },

  listingIndex: {
    title: "Oferty",
    subtitle: "Zarządzanie centralną konfiguracją każdej z ofert.",
    countFiltered: "{shown} z {total} ofert",
    count: "{count} oferta | {count} oferty | {count} ofert",
    searchPlaceholder: "Szukaj po nazwie, ID albo typie…",
    clear: "Wyczyść",
    loadErrorTitle: "Nie udało się wczytać obiektów",
    retry: "Spróbuj ponownie",
    emptyTitle: "Brak ofert",
    emptyText: "Nie ma tu jeszcze żadnych zarejestrowanych ofert.",
    noResultsTitle: 'Brak wyników dla „{query}”',
    noResultsText: "Proszę spróbować innej nazwy, ID albo typu oferty.",
    clearSearch: "Wyczyść wyszukiwanie",
    dragSearchHint: "Trzeba wyczyścić wyszukiwanie, aby zmienić kolejność",
    dragHint: "Przeciągnij, aby zmienić kolejność",
    units: "{count} jednostka | {count} jednostki | {count} jednostek",
    botActiveTitle: "Bot GPT aktywny",
    channelTitle: "Połączono z Channex",
    icalTitle: "Synchronizacja iCal",
    editTitle: "Edytuj nazwę",
    modal: {
      title: "Edytuj nazwę oferty",
      nameLabel: "Nazwa oferty",
      namePlaceholder: "Np. Apartamenty Costa Sol",
      orderLabel: "Kolejność oferty",
      info: "<strong>Oferta</strong> grupuje wszystkie obiekty, które mają tę samą konfigurację, wiadomości powitalne i zasady. Ustawiona tu nazwa będzie identyfikować grupę w panelu i w podłączonych kanałach dystrybucji.",
      cancel: "Anuluj",
      save: "Zapisz zmiany",
    },
    types: {
      apartment: "Apartament",
      house: "Dom",
      villa: "Willa",
      hotel: "Hotel",
      room: "Pokój",
      studio: "Kawalerka",
      default: "Obiekt",
    },
    toast: {
      connectionError: "Błąd połączenia.",
      reorderSuccess: "Kolejność zaktualizowana pomyślnie.",
      reorderError: "Nie udało się zaktualizować kolejności ofert.",
      saveSuccess: "Oferta zaktualizowana pomyślnie.",
      saveError: "Błąd podczas zapisywania oferty.",
    },
  },

  unitDetail: {
    back: "Powrót do oferty",
    eyebrow: "Jednostka",
    save: "Zapisz",
    cancel: "Anuluj",
    editNameTitle: "Edytuj nazwę jednostki",
    nameFallback: "Jednostka",
    types: {
      apartment: "Apartament",
      house: "Dom",
      villa: "Willa",
      hotel: "Hotel",
      camping: "Kemping",
      room: "Pokój",
      studio: "Kawalerka",
      default: "Obiekt",
    },
    deleteLink: "Usuń jednostkę...",
    dangerNoteBefore: "Usuwa jednostkę z oferty",
    dangerNoteAfter: "w WACheckin. Tej operacji nie da się cofnąć.",
    cards: {
      description: { title: "Opis", sub: "Szczegóły jednostki" },
      capacity: { title: "Pojemność", sub: "Goście i łóżka" },
      services: { title: "Wyposażenie i udogodnienia", sub: "Co oferuje, ze zdjęciami" },
      rules: { title: "Godziny", sub: "Godziny check-inu i check-outu" },
      arrival: { title: "Instrukcje przyjazdu", sub: "Jak dojechać i wejść · z godziną wysyłki" },
      smartlocks: { title: "Zamki i dostęp", sub: "Jak gość wchodzi do środka" },
      checkout: { title: "Wiadomość o check-oucie", sub: "Przypomnienie o wyjeździe · szablon" },
      scheduled: { title: "Zaplanowane wiadomości", sub: "Wiadomości tylko dla tej jednostki" },
      unitFaq: { title: "Pytania i odpowiedzi", sub: "Właściwe tej jednostce, dla agenta", badge: "AI" },
      welcome: { title: "Wiadomość powitalna", sub: "Wiadomość właściwa tej jednostce" },
      stockExtra: {
        title: "Zapas dodatkowy",
        subOff: "Wyłączone · przejmuje rezerwacje z innej jednostki",
        subOn: "Zapas dla: {name}",
        subOnGeneric: "Zapas dla innej jednostki",
        badge: "Wł.",
      },
    },
    sections: {
      aiOnlyLabel: "Najczęstsze pytania dla tej jednostki",
      aiOnlyDesc: "Agent potraktuje je priorytetowo, obsługując gościa przebywającego w tej jednostce.",
      specificLabel: "Ustawienia właściwe tej jednostce",
      detailLabel: "Szczegółowy opis tej jednostki",
      detailDesc: "Dodatkowe informacje, których używamy przy rezerwacjach bezpośrednich i do zasilania Agenta AI.",
    },
    stockExtra: {
      title: "Zapas dodatkowy",
      intro: "W Booking albo Airbnb może być jedna oferta obejmująca kilka mieszkań: skoro zmapować można tylko jedno, kanał wysyła wszystkie te rezerwacje na tę samą jednostkę i piętrzą się one jako overbooking.",
      how: "Po oznaczeniu tej jednostki jako zapasu dodatkowego innej jednostki rezerwacje kolidujące z jednostką główną zapisują się tutaj, a kanał dostaje informację, żeby tam również pokazywały się w tej jednostce.",
      purpose: "To narzędzie przejściowe: warto je włączyć, aby przenieść to, co zostało już sprzedane w OTA, i wyłączyć, gdy każde mieszkanie ma własną ofertę.",
      loading: "Wczytywanie...",
      activeLabel: "Zapas dla: {name}",
      activeHint: "Rezerwacje z kanału, które kolidują z jednostką główną, zapisują się w tej jednostce. Jednostka główna: {name}.",
      activeBadge: "Wł.",
      otherUnit: "inna jednostka",
      warnTitle: "Nie należy tego włączać, jeśli każde mieszkanie ma już własną ofertę zmapowaną w OTA:",
      warnText: "kanał wysyła wtedy każdą rezerwację do właściwej jednostki, a przy włączonym zapasie dodatkowym rezerwacja trafiłaby do innego mieszkania niż sprzedane.",
      principalOf: "Inne jednostki już opierają się na tej:",
      chooseLabel: "Jednostka główna",
      chooseDesc: "Proszę wybrać jednostkę, której rezerwacje będą zapisywane w „{unit}”, gdy zaczną ze sobą kolidować.",
      noCandidates: "W tej ofercie nie ma innej jednostki, dla której można być zapasem.",
      activate: "Włącz zapas dodatkowy",
      change: "Zmień jednostkę główną",
      saving: "Zapisywanie...",
      removeBtn: "Usuń zapas dodatkowy",
      removeNote: "Rezerwacje już tu zapisane nie są przenoszone: zostają w tej jednostce.",
      errorCarga: "Nie udało się wczytać ustawień zapasu dodatkowego. Po niedawnej aktualizacji warto odświeżyć stronę.",
      reintentar: "Spróbuj ponownie",
      toastLoadError: "Nie udało się wczytać zapasu dodatkowego.",
      toastSaveError: "Nie udało się zapisać zapasu dodatkowego.",
    },
    toast: {
      nameEmpty: "Nazwa nie może być pusta",
      nameUpdated: "Nazwa zaktualizowana",
      nameError: "Nie udało się zaktualizować nazwy",
    },
  },

  miCuenta: {},
};
